import { render, staticRenderFns } from "./EditBuilding.vue?vue&type=template&id=02679624"
import script from "./EditBuilding.vue?vue&type=script&lang=js"
export * from "./EditBuilding.vue?vue&type=script&lang=js"
import style0 from "./EditBuilding.vue?vue&type=style&index=0&id=02679624&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports